import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Fallback image shown on listings with no photo (mountain-town HOTEL building)
export const DEFAULT_HOTEL_IMAGE = "https://static.prod-images.emergentagent.com/jobs/ef4b9bcb-71fc-4c1f-9406-0c21cdc3571a/images/c2b122d5923e26dd35b285f1615ad9492fbf8af30e5336232894bd872fa08f6b.jpeg";

const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("rb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  register: (body) => http.post("/auth/register", body).then((r) => r.data),
  login: (body) => http.post("/auth/login", body).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),

  createSales: (body) => http.post("/sales", body).then((r) => r.data),
  listSales: () => http.get("/sales").then((r) => r.data),
  listAssignable: (hotelId) => http.get("/assignable", { params: hotelId ? { hotel_id: hotelId } : {} }).then((r) => r.data),
  createTeamMember: (body) => http.post("/team", body).then((r) => r.data),
  listTeam: () => http.get("/team").then((r) => r.data),
  updateMemberProperties: (id, property_ids) => http.put(`/team/${id}/properties`, { property_ids }).then((r) => r.data),
  updateTeamMember: (id, body) => http.put(`/team/${id}`, body).then((r) => r.data),
  removeTeamMember: (id) => http.delete(`/team/${id}`).then((r) => r.data),
  myProperties: () => http.get("/my-properties").then((r) => r.data),
  frontDeskAccounts: () => http.get("/front-desk/accounts").then((r) => r.data),
  frontDeskEnquiry: (body) => http.post("/front-desk/enquiry", body).then((r) => r.data),
  frontDeskEnquiries: () => http.get("/front-desk/enquiries").then((r) => r.data),
  claimLead: (id) => http.put(`/leads/${id}/claim`).then((r) => r.data),

  hotels: (params = {}) => http.get("/hotels", { params }).then((r) => r.data),
  cities: () => http.get("/hotels/cities").then((r) => r.data),
  searchArea: (params) => http.get("/hotels/search-area", { params }).then((r) => r.data),
  hotel: (id) => http.get(`/hotels/${id}`).then((r) => r.data),
  createHotel: (body) => http.post("/hotels", body).then((r) => r.data),
  updateHotel: (id, body) => http.put(`/hotels/${id}`, body).then((r) => r.data),
  deleteHotel: (id) => http.delete(`/hotels/${id}`).then((r) => r.data),

  nearby: (hotelId, radius, focus = "all") =>
    http.get(`/hotels/${hotelId}/nearby-companies`, { params: { radius, focus } }).then((r) => r.data),
  airports: (hotelId) => http.get(`/hotels/${hotelId}/airports`).then((r) => r.data),

  leads: (params = {}) => http.get("/leads", { params }).then((r) => r.data),
  leadFilters: () => http.get("/leads-filters").then((r) => r.data),
  lead: (id) => http.get(`/leads/${id}`).then((r) => r.data),
  createLead: (body) => http.post("/leads", body).then((r) => r.data),
  deleteLead: (id, reason = "") => http.delete(`/leads/${id}`, { params: { reason } }).then((r) => r.data),
  assignLead: (id, sales_id) => http.put(`/leads/${id}/assign`, { sales_id }).then((r) => r.data),
  leadStatus: (id, status, note = "", file = null) =>
    http.put(`/leads/${id}/status`, { status, note, file }).then((r) => r.data),
  leadActivity: (id, text, file = null, kind = "note") =>
    http.post(`/leads/${id}/activity`, { text, file, kind }).then((r) => r.data),
  addReminder: (id, date, note) => http.post(`/leads/${id}/reminders`, { date, note }).then((r) => r.data),
  toggleReminder: (id, rid) => http.put(`/leads/${id}/reminders/${rid}/toggle`).then((r) => r.data),
  deleteReminder: (id, rid) => http.delete(`/leads/${id}/reminders/${rid}`).then((r) => r.data),
  addPastBusiness: (id, body) => http.post(`/leads/${id}/past-business`, body).then((r) => r.data),
  deletePastBusiness: (id, eid) => http.delete(`/leads/${id}/past-business/${eid}`).then((r) => r.data),
  addSpaceEntry: (id, body) => http.post(`/leads/${id}/space-entries`, body).then((r) => r.data),
  addSpaceEntriesBulk: (id, bodies) => http.post(`/leads/${id}/space-entries/bulk`, bodies).then((r) => r.data),
  updateSpaceEntry: (id, eid, body) => http.put(`/leads/${id}/space-entries/${eid}`, body).then((r) => r.data),
  deleteSpaceEntry: (id, eid) => http.delete(`/leads/${id}/space-entries/${eid}`).then((r) => r.data),
  spaceEntries: (params = {}) => http.get("/space-entries", { params }).then((r) => r.data),
  // Meeting rooms
  meetingRooms: (hotel_id) => http.get("/meeting-rooms", { params: { hotel_id } }).then((r) => r.data),
  createMeetingRoom: (body) => http.post("/meeting-rooms", body).then((r) => r.data),
  updateMeetingRoom: (id, body) => http.put(`/meeting-rooms/${id}`, body).then((r) => r.data),
  deleteMeetingRoom: (id) => http.delete(`/meeting-rooms/${id}`).then((r) => r.data),
  // Events + functions
  events: (params = {}) => http.get("/events", { params }).then((r) => r.data),
  event: (id) => http.get(`/events/${id}`).then((r) => r.data),
  createEvent: (body) => http.post("/events", body).then((r) => r.data),
  updateEvent: (id, body) => http.put(`/events/${id}`, body).then((r) => r.data),
  deleteEvent: (id) => http.delete(`/events/${id}`).then((r) => r.data),
  addFunction: (eventId, body) => http.post(`/events/${eventId}/functions`, body).then((r) => r.data),
  updateFunction: (eventId, fnId, body) => http.put(`/events/${eventId}/functions/${fnId}`, body).then((r) => r.data),
  deleteFunction: (eventId, fnId) => http.delete(`/events/${eventId}/functions/${fnId}`).then((r) => r.data),
  functionDiary: (hotel_id) => http.get("/function-diary", { params: { hotel_id } }).then((r) => r.data),
  // Room types (property guest-room inventory)
  roomTypes: (hotel_id) => http.get("/room-types", { params: { hotel_id } }).then((r) => r.data),
  createRoomType: (body) => http.post("/room-types", body).then((r) => r.data),
  updateRoomType: (id, body) => http.put(`/room-types/${id}`, body).then((r) => r.data),
  deleteRoomType: (id) => http.delete(`/room-types/${id}`).then((r) => r.data),
  // Accounts + activity + reports
  activityKinds: () => http.get("/activity-kinds").then((r) => r.data),
  accounts: (params = {}) => http.get("/accounts", { params }).then((r) => r.data),
  account: (id) => http.get(`/accounts/${id}`).then((r) => r.data),
  createAccount: (body) => http.post("/accounts", body).then((r) => r.data),
  accountBookings: (id) => http.get(`/accounts/${id}/bookings`).then((r) => r.data),
  allBookings: (params = {}) => http.get("/all-bookings", { params }).then((r) => r.data),
  deletedLeads: () => http.get("/deleted-leads").then((r) => r.data),
  restoreDeletedLead: (id) => http.post(`/deleted-leads/${id}/restore`).then((r) => r.data),
  createBooking: (id, body) => http.post(`/accounts/${id}/bookings`, body).then((r) => r.data),
  updateBooking: (id, bid, body) => http.put(`/accounts/${id}/bookings/${bid}`, body).then((r) => r.data),
  deleteBooking: (id, bid) => http.delete(`/accounts/${id}/bookings/${bid}`).then((r) => r.data),
  salesReport: (params = {}) => http.get("/reports/sales-activity", { params }).then((r) => r.data),
  createIntakeLink: (body) => http.post("/intake-links", body).then((r) => r.data),
  emailIntakeLink: (body) => http.post("/intake-links/email", body).then((r) => r.data),
  publicIntakeInfo: (token) => http.get(`/public/intake/${token}`).then((r) => r.data),
  publicIntakeSubmit: (token, body) => http.post(`/public/intake/${token}`, body).then((r) => r.data),
  upcomingReminders: () => http.get("/reminders/upcoming").then((r) => r.data),
  leadStats: () => http.get("/leads-stats").then((r) => r.data),

  rfps: (params = {}) => http.get("/rfps", { params }).then((r) => r.data),
  rfp: (id) => http.get(`/rfps/${id}`).then((r) => r.data),
  createRfp: (body) => http.post("/rfps", body).then((r) => r.data),
  createRateRequest: (body) => http.post("/rfps/rate-request", body).then((r) => r.data),
  rateRequests: () => http.get("/rate-requests").then((r) => r.data),
  gmRateRequests: () => http.get("/rate-requests/gm").then((r) => r.data),
  claimRateRequest: (id, hotel_id, counter_rate = null) =>
    http.post(`/rate-requests/${id}/claim`, { hotel_id, counter_rate }).then((r) => r.data),
  publicRateRequest: (id) => http.get(`/public/rate-requests/${id}`).then((r) => r.data),

  messages: (rfpId) => http.get(`/rfps/${rfpId}/messages`).then((r) => r.data),
  sendMessage: (body) => http.post("/messages", body).then((r) => r.data),

  contracts: () => http.get("/contracts").then((r) => r.data),
  createContract: (body) => http.post("/contracts", body).then((r) => r.data),
  setContractStatus: (id, status) =>
    http.put(`/contracts/${id}/status`, null, { params: { status } }).then((r) => r.data),
  emailContract: (id, body) => http.post(`/contracts/${id}/email`, body).then((r) => r.data),
  emailLeadContract: (id, body) => http.post(`/leads/${id}/email-contract`, body).then((r) => r.data),
  leadMessages: (id) => http.get(`/leads/${id}/messages`).then((r) => r.data),
  sendLeadMessage: (id, body) => http.post(`/leads/${id}/messages`, body).then((r) => r.data),

  bookings: () => http.get("/bookings").then((r) => r.data),
  createCompanyBooking: (body) => http.post("/bookings", body).then((r) => r.data),
  cancelBooking: (id) => http.put(`/bookings/${id}/cancel`).then((r) => r.data),

  hotelAnalytics: () => http.get("/analytics/hotel").then((r) => r.data),
  companyAnalytics: () => http.get("/analytics/company").then((r) => r.data),
};

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return fallback;
};

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export const dateFmt = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return s;
  }
};

export const LEAD_STAGES = ["new", "contacted", "qualified", "proposal", "won", "lost"];
export const LEAD_CATEGORIES = ["Corporate/Crew", "Government", "SMERF", "Sporting", "Other"];
export const STAGE_LABEL = {
  new: "New", contacted: "Contacted", qualified: "Qualified",
  proposal: "Proposal Sent", won: "Won", lost: "Lost",
};

export const HOTEL_BRANDS = [
  "Independent",
  "Best Western",
  "Choice (Comfort/Quality/Sleep)",
  "Hilton (Hampton/Hilton Garden)",
  "Marriott (Courtyard/Fairfield)",
  "IHG (Holiday Inn/Candlewood)",
  "Wyndham (Days Inn/La Quinta)",
  "Motel 6 / Studio 6",
  "Red Roof Inn",
  "Extended Stay America",
  "Other (custom)",
];


export const EVENT_STATUSES = ["definite", "tentative", "block", "bc"];
export const EVENT_STATUS_META = {
  definite: { label: "Definite", color: "#16A34A", bg: "#DCFCE7" },
  tentative: { label: "Tentative", color: "#D97706", bg: "#FEF3C7" },
  block: { label: "Block", color: "#2563EB", bg: "#DBEAFE" },
  bc: { label: "B&C", color: "#7C3AED", bg: "#EDE9FE" },
};
